export const OUTSTANDING_PAYMENTS_ENDPOINT = {
  getList: {
    url: '/v1/admin/outstanding-payments',
    method: 'GET',
  },
  getDetail: (customerId) => ({
    url: `/v1/admin/outstanding-payments/${customerId}`,
    method: 'GET',
  }),
  sendPaymentLink: {
    url: '/v1/admin/outstanding-payments/send-payment-link',
    method: 'POST',
  },
  markPaid: {
    url: '/v1/admin/outstanding-payments/mark-paid',
    method: 'POST',
  },
};
